import { IUser, UserRole } from '@localina/core';

export const setUserRole = (user: IUser, restaurantId: string, role?: UserRole): IUser => ({
    ...user,
    rolesMapping: [
        ...user.rolesMapping.filter((mapping) => mapping.restaurantId !== restaurantId),
        ...(role ? [{ restaurantId, roles: [role] }] : []),
    ],
});

export const setUserRoles = (user: IUser, restaurantIds: string[], role?: UserRole): IUser =>
    restaurantIds.reduce((current, restaurantId) => setUserRole(current, restaurantId, role), user);

export const countRoles = (user: IUser, restaurantIds: string[]) => {
    const counts = new Map<UserRole, number>();
    let none = 0;
    restaurantIds.forEach((restaurantId) => {
        const mapping = user.rolesMapping.find((item) => item.restaurantId === restaurantId);
        const role = mapping && mapping.roles.length > 0 ? mapping.roles[0] : undefined;
        if (role) {
            counts.set(role, (counts.get(role) ?? 0) + 1);
        } else {
            none += 1;
        }
    });
    return { counts, none };
};
